import { I18nService } from './i18n.service';
import { Injectable } from '@angular/core';
import { MappedInvestmentDocuments } from './investments.service';
import * as R from 'ramda';
import { deburr } from "lodash";

/**
 * Service that tracks selected start and end year through route query params.
 */
@Injectable()
export class UtilsService {

  constructor(
    private i18n: I18nService,
  ) { }

  public formateNumber(number): string {
    return new Intl.NumberFormat(this.i18n.getCulture(), { style: 'decimal' }).format(number);
  }

  public round2dec(number, decPlace: number = 2): number {
    let x = 100;
    if (decPlace !== 2) {
      x = 1;
      for (let i = 0; i < decPlace; i++) {
        x = x * 10;
      }
    }

    if (number !== null && number !== Infinity) {
      return Math.round((number + Number.EPSILON) * x) / x;
    }
    return null;
  }

  public getInvestmentsTotalPrice(
    investments: MappedInvestmentDocuments[],
    years?: number[],
  ): string {
    return this.i18n.formatCurrency(
      this.computeInvestmentsTotalPrice(investments, years),
    );
  }

  public computeInvestmentsTotalPrice(
    investments: MappedInvestmentDocuments[],
    years?: number[],
    onlyExtraWork: boolean = false,
    onlyAdditionalPrice: boolean = false,
  ): number {
    return investments.reduce((acc, inv) => {
      return (acc += inv.slices
        .filter((s) => s.status === inv.status && (!years || years.includes(s.year)) && (!onlyExtraWork || s.is_extra_work))
        .map((s) => onlyAdditionalPrice ? (Number(s.additional_price) || 0) : (Number(s.price) | 0) + (Number(s.additional_price) | 0))
        .reduce((a, b) => a + b, 0));
    }, 0) || 0;
  }

  public static getKey(args: any): string {
    return JSON.stringify(R.pickBy(R.complement(R.isNil), args));
  }

  public static makeRandomId(): number {
    return Math.floor(Math.random() * 1000000);
  }

  public openPopupWindow(popupUrl: string) {
    // const token = "AUDIT_POPUP_TOKEN"
    const screenWidth = window.screen.availWidth;
    const screenHeight = window.screen.availHeight;
    const popupWidth = Math.floor(screenWidth / 2 - 60);
    const popupHeight = screenHeight;

    const screenLeft = window.screenLeft || window.screenX || 0;
    const leftPosition = screenLeft + screenWidth - popupWidth;

    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${popupWidth},height=${popupHeight},left=${leftPosition},top=0`;
    // @ts-ignore
    if (!window._KPIWindow || (window._KPIWindow && window._KPIWindow.closed)) {
      window.focus();
      setTimeout(() => {
        // @ts-ignore
        window._KPIWindow = window.open(popupUrl, "_blank", params);
      }, 200);
    } else {
      setTimeout(() => {
        // @ts-ignore
        window._KPIWindow.focus()
        // @ts-ignore
        window._KPIWindow.location.replace(popupUrl)
      }, 0);
    }

  }

}

export function formatSearchString(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function cleanFilterString(input: string): string {
  return input ? deburr(input.trim().toLowerCase()) : null;
}

export function anyWordBeginWith(string: string, query: string): boolean {
  const cleanString = cleanFilterString(string);
  const cleanQuery = cleanFilterString(query);

  if (!cleanString || !cleanQuery) {
    return false;
  }

  const stringWords = cleanString.split(" ").filter(word => word.length > 0);
  const queryWords = cleanQuery.split(" ").filter(word => word.length > 0);

  if (queryWords.length === 0) {
    return false;
  }

  return queryWords.every(queryWord =>
    !!stringWords.find(stringWord => stringWord.startsWith(queryWord))
  );
}

export function firstLetterUpperCase(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
